// extracted by mini-css-extract-plugin
module.exports = {"main":"detail_main__RF0-l","slickSlide":"detail_slickSlide__1gu0l","item":"detail_item__dkKw8","footer":"detail_footer__2ZHKy","footerText":"detail_footerText__2qNXx"};